export const projects = [
	{
		img: 'https://github.com/vcow10kar/seekho-project/raw/master/snapshots/homepagewithnavbarandfooter.png',
		title: 'Seekho',
		des: 'Seekho is an e-learning web application where user can read and download books of there choice.',
		demo: '',
		live: ' https://seekho-frontend-vcow10kar.vercel.app/',
		gitHub: 'https://github.com/vcow10kar/seekho-project',
		technologies: [ 'MondoDB','ExpressJS','ReactJS','NodeJS', 'HTML', 'CSS', 'javaScript'],
	},
	{
		img: 'https://files.myglamm.com/site-images/original/Offer-of-the-week-Desktop-Multipurpose_1.jpg',
		title: '	Myglamm clone',
		des: 'This is a clone of a  e-commerce website for variety of cosmetic products build with HTML,CSS,JavaScript,Express,Node.js and MongoDB. Have features which allows user to search products on the basis of different categories. ',
		demo: '',
		live: 'https://myglamm.com/', // deployed link
		gitHub: 'https://github.com/suvamAdhikary/MyGlamm-with-Backend',
		technologies: ['MongoDB','ExpressJS', 'NodeJs', 'ejs', 'CSS', 'JavaScript'],
	},

];
